import React from "react";
import { useEffect } from "react";
import { MainLayout } from "../MainLayout";
import { ContactSec1 } from "./ContactSec1";
import { ContactSec3 } from "./ContactSec3";
import { ContactSec4 } from "./ContactSec4";
import { Footer } from "../Footer";
import { ContactSec5 } from "./ContactSec5";
import { Introduction } from "../../Common/Introduction";

export const ContactUs = () => {
  const details = {
    // title: "CONTACT US",
    head: "CONNECT WITH YOUR TRUSTED DMC PARTNER ",
    text: [
      <div className="mt-0">
        Looking to create seamless travel experiences for your clients? Let’s
        make it happen. At Blueberry DMC, we collaborate closely with travel
        agents and partners to design authentic journeys, manage on-ground
        operations, and deliver exceptional service across our destinations.
      </div>,

      <div>
        Reach out to us today for expert regional insights, competitive rates,
        and reliable assistance that empowers your business to grow.
      </div>,

     <div className="mt-0">
  Have questions or need quick support? Drop us an{" "}
  
  <a
    href="mailto:holidays@Blueberrydmc.com"
    style={{
      color: "rgb(19, 70, 133)",
      fontWeight: "600",
      textDecoration: "none",
    }}
  >
    email
  </a>{" "}
  
  or{" "}
  
  <a
    href="tel:+971559886749"
    style={{
      color: "rgb(19, 70, 133)",
      fontWeight: "600",
      textDecoration: "none",
    }}
  >
    call
  </a>{" "}
  
  — our team is here to help, every step of the way.
</div>
    ],
  };
  useEffect(() => {
    const el = document.getElementById("contact-sec1-id");

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, []);

  return (
    <>
      <MainLayout
        contactuspage={true}
        bgImage={
          'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/contact%20us/contact%20us.webp")'
        }
        text1={"GET IN TOUCH "}
        text2={"Let’s Connect and Build Something Together! "}
        button={true}
      />
      <Introduction data={details} />
      <ContactSec1 />
      <ContactSec4 />
      <ContactSec3 />
      <ContactSec5 />
      <Footer />
    </>
  );
};
